export default __webpack_public_path__ + "static/media/MODELUN.9bf0dfa4.svg";